
export default {
    name: 'SvgTires',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
